export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00810.e6724f43.png";